<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells><h2 class="title">New</h2></app-cells>
      <v-client-table
        :data="table_new.items"
        :columns="table_new.columns"
        :options="table_new.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link
              :to=" { name: 'fast-track-detail', params: { id: row.id } }"
              class="table-default__link-border"
            >
              {{ row.name }}
            </router-link>
          </div>
        </template>
        <template #location="{ row }">{{ row.location.short_name }}</template>
        <template #arrival="{ row }">
          <template v-if="row.arrival_transfer">
            {{ dateFormat(row.arrival_transfer.transport_date) }} {{ row.arrival_transfer.transport_time }} | {{ row.arrival_transfer.transport_flight_number }} ({{ row.arrival_transfer.transport_company.name }})
          </template>
          <template v-else>-</template>
        </template>
        <template #departure="{ row }">
          <template v-if="row.departure_transfer">
            {{ dateFormat(row.departure_transfer.transport_date) }} {{ row.departure_transfer.transport_time }} | {{ row.departure_transfer.transport_flight_number }} ({{ row.departure_transfer.transport_company.name }})
          </template>
          <template v-else>-</template>
        </template>
      </v-client-table>
      <app-cells><h2 class="title">Requested</h2></app-cells>
      <v-client-table
        :data="table_requested.items"
        :columns="table_requested.columns"
        :options="table_requested.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link
              :to=" { name: 'fast-track-detail', params: { id: row.id } }"
              class="table-default__link-border"
            >
              {{ row.name }}
            </router-link>
          </div>
        </template>
        <template #location="{ row }">{{ row.location.short_name }}</template>
        <template #arrival="{ row }">
          <template v-if="row.arrival_transfer">
            {{ dateFormat(row.arrival_transfer.transport_date) }} {{ row.arrival_transfer.transport_time }} | {{ row.arrival_transfer.transport_flight_number }} ({{ row.arrival_transfer.transport_company.name }})
          </template>
          <template v-else>-</template>
        </template>
        <template #departure="{ row }">
          <template v-if="row.departure_transfer">
            {{ dateFormat(row.departure_transfer.transport_date) }} {{ row.departure_transfer.transport_time }} | {{ row.departure_transfer.transport_flight_number }} ({{ row.departure_transfer.transport_company.name }})
          </template>
          <template v-else>-</template>
        </template>
        <template #requested="{ row }">
          <div class="table-default__left">
            <div v-if="row.requested_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.requested_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.requested_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.requested_at) }}
            </div>
          </div>
        </template>
      </v-client-table>
      <app-cells><h2 class="title">Confirmed</h2></app-cells>
      <v-client-table
        :data="table_confirmed.items"
        :columns="table_confirmed.columns"
        :options="table_confirmed.options"
        class="table-default"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #name="{ row }">
          <div class="table-default__left">
            <router-link
              :to=" { name: 'fast-track-detail', params: { id: row.id } }"
              class="table-default__link-border"
            >
              {{ row.name }}
            </router-link>
          </div>
        </template>
        <template #location="{ row }">{{ row.location.short_name }}</template>
        <template #arrival="{ row }">
          <template v-if="row.arrival_transfer">
            {{ dateFormat(row.arrival_transfer.transport_date) }} {{ row.arrival_transfer.transport_time }} | {{ row.arrival_transfer.transport_flight_number }} ({{ row.arrival_transfer.transport_company.name }})
          </template>
          <template v-else>-</template>
        </template>
        <template #departure="{ row }">
          <template v-if="row.departure_transfer">
            {{ dateFormat(row.departure_transfer.transport_date) }} {{ row.departure_transfer.transport_time }} | {{ row.departure_transfer.transport_flight_number }} ({{ row.departure_transfer.transport_company.name }})
          </template>
          <template v-else>-</template>
        </template>
        <template #confirmed="{ row }">
          <div class="table-default__left">
            <div v-if="row.confirmed_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.confirmed_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.confirmed_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.confirmed_at) }}
            </div>
          </div>
        </template>
      </v-client-table>
    </template>
  </div>
</template>

<script>
import { getTransfersFastTrackList } from '@/http'
import { format, parse, parseISO } from 'date-fns'

export default {
  name: 'FastTrackUpcoming',
  data() {
    return {
      is_loaded: false,
      table_new: {
        items: [],
        columns: ['name', 'location', 'arrival', 'departure'],
        options: {
          headings: {
            name: 'Name',
            location: 'Location',
            arrival: 'Arrival',
            departure: 'Departure',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_requested: {
        items: [],
        columns: ['name', 'location', 'arrival', 'departure', 'requested'],
        options: {
          headings: {
            name: 'Name',
            location: 'Location',
            arrival: 'Arrival',
            departure: 'Departure',
            requested: 'Requested by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      table_confirmed: {
        items: [],
        columns: ['name', 'location', 'arrival', 'departure', 'confirmed'],
        options: {
          headings: {
            name: 'Name',
            location: 'Location',
            arrival: 'Arrival',
            departure: 'Departure',
            confirmed: 'Confirmed by',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 50,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
  created() {
    Promise.all([
      getTransfersFastTrackList({ requested: false }),
      getTransfersFastTrackList({ requested: true, confirmed: false }),
      getTransfersFastTrackList({ confirmed: true, paid: false }),
    ])
      .then(res => {
        this.table_new.items = res[0].data
        this.table_requested.items = res[1].data
        this.table_confirmed.items = res[2].data

        this.is_loaded = true
      })
  },
  methods: {
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
    formatDateTime(date) {
      if (!date) return ''
      return format(parseISO(date), 'dd MMMM yyyy HH:mm')
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
  }
}
</script>
